import React, { MouseEvent, ReactNode } from 'react';

import useTheme from '../../../hooks/use-theme/useTheme';

import { getClassNames } from '../../../utils/util';

import './button.scss';

type Props = {
  text: string;
  disabled?: boolean;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  icon?: ReactNode;
  auth?: boolean;
  secondary?: boolean;
  className?: string;
};

const Button = ({ text, disabled = false, onClick, icon, auth = false, secondary = false, className = '' }: Props) => {
  const { pps } = useTheme();

  return (
    <button
      className={`${getClassNames('button', { auth, secondary, pps })} ${className}`}
      disabled={disabled}
      onClick={onClick}
    >
      {icon && icon}
      {text}
    </button>
  );
};

export default Button;
